import { Component } from '@angular/core';

@Component({
  selector: 'app-testimonials-page',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsPageComponent {
  testimonials = [
    {
      name: 'Jan V.',
      location: 'Amsterdam',
      text: 'Via Kansino Nederland heb ik een geweldige betting site gevonden met een uitstekende welkomstbonus. De site is betrouwbaar en snel.',
      rating: 5
    },
    {
      name: 'Maria K.',
      location: 'Rotterdam',
      text: 'Ik waardeer de duidelijke beoordelingen en vergelijkingen. Het heeft me geholpen een weloverwogen keuze te maken.',
      rating: 5
    },
    {
      name: 'Pieter D.',
      location: 'Utrecht',
      text: 'De klantenservice van de site die ik via Kansino Nederland heb gevonden is uitstekend. Zeer tevreden!',
      rating: 4
    },
    {
      name: 'Sophie M.',
      location: 'Den Haag',
      text: 'Fantastische ervaring! De aanbevelingen zijn accuraat en de bonussen zijn echt zoals beschreven.',
      rating: 5
    },
    {
      name: 'Tom B.',
      location: 'Eindhoven',
      text: 'Zeer gebruiksvriendelijke website met duidelijke informatie. Ik zou het zeker aanbevelen aan anderen.',
      rating: 5
    },
    {
      name: 'Lisa H.',
      location: 'Groningen',
      text: 'De vergelijkingen zijn zeer nuttig geweest. Ik heb de perfecte site gevonden voor mijn behoeften.',
      rating: 4
    }
  ];
}

